// src/DropdownSearch.js
import React, { useState } from "react";
import "./style.css"; // Import the CSS file

const courses = [
  "PhD - Doctorate",
"Master Degree",
"Postgraduate Certificate",
"Postgraduate Bundle Certificates",
"Bachelor Degree",
"Associate Degree",
"Advanced Diploma - 3 Years",
"Diploma - 2 Year"
];

const countries = [
  "Canada",
  "United Kingdom",
  "Australia",
  "USA",
  "Hungary",
  "Lithuania",
  "Poland",
  "New Zeland"
];
const cateories = [
  "Engineering",
  "Business",
  "Information Technology",
  "Health Science",
  "Science",
  "Hospitality & Tourism",
  "Art & Design",
];

const DropdownSearch = ({ selectedCountry, selectedCourse, selectStream, onCountryChange, onCourseChange, onStreamChange }) => {



  return (
    <div style={{paddingLeft:20,}}>
      <h1>Search Study Programs</h1>
      <div className="dropdown-search-container">
        <select
          value={selectedCountry}
          onChange={(e) => onCountryChange(e.target.value)}
          style={{ flex: 1 }}
        >
          <option style={{}} value="">Select Country</option>
          {countries.map((country, index) => (
            <option key={index} value={country}>
              {country}
            </option>
          ))}
        </select>
        <select
          value={selectedCourse}
          onChange={(e) => onCourseChange(e.target.value)}
          style={{ flex: 1 }}
        >
          <option value="">Select Study Level</option>
          {courses.map((course, index) => (
            <option key={index} value={course}>
              {course}
            </option>
          ))}
        </select>
        <select
          value={selectStream}
          onChange={(e) => onStreamChange(e.target.value)}
          style={{ flex: 1 }}
        >
          <option value="">Select Study Category</option>
          {cateories.map((course, index) => (
            <option key={index} value={course}>
              {course}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DropdownSearch;
